export default __webpack_public_path__ + "static/media/chris-liverani-5oZ9uVx7buc-unsplash.11d63b76.jpg";